import { render, staticRenderFns } from "./UsersSelector.vue?vue&type=template&id=c42fd7f2&scoped=true&"
import script from "./UsersSelector.vue?vue&type=script&lang=ts&"
export * from "./UsersSelector.vue?vue&type=script&lang=ts&"
import style0 from "./UsersSelector.vue?vue&type=style&index=0&id=c42fd7f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42fd7f2",
  null
  
)

export default component.exports